module.exports = __webpack_public_path__ + "img/icon-delete.17981eed.svg";